module.exports = __webpack_public_path__ + "img/folder-bookmark.26f30085.svg";